import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  components: {},
  mixins: [style],
})
export default class Picture extends Vue {
  @Prop({ default: () => {} })
    value: ItemObject;

  render(h) {
    return (
      <div class="picture bg-white" style={`height:${this.value.desc.pictureUrl ? '' : '300px'};`}>
        <img class="width-100" src={this.value.desc.pictureUrl ? this.value.desc.pictureUrl : ''}></img>
      </div>
    );
  }
}
